module.exports = __webpack_public_path__ + "static/media/awaria-samochodu.1e423e61.svg";